module.exports = __webpack_public_path__ + "static/img/12.626937d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/12.png
// module id = p9DG
// module chunks = 0